import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import {
  Diocese,
  Organisation,
  Error,
  JobTitle,
  AccountRole,
  OrganisationStatus,
} from "../../../../models";
import { CurrentUserService } from "../../../../services/shared";
import { CommonUtility } from "../../../../utils/commonUtility";
import { CONFIGURATION } from "../../../../app.constants";
import { USERHOMECONSTANTS } from "../../userHome.constants";
import { UserHomeService } from "../../userHome.service";
import { StaticUserDataService } from "../../../../services/staticUserData.service";
import { UserOrganisationInfoService } from "./organisationInfo.service";
import { NgProgressService } from "ng2-progressbar";
import * as swal from "sweetalert2";
const _ = require("underscore");

@Component({
  selector: "organisation-info",
  template: `
    <div [ngSwitch]="isAddEditUIMode">
      <template [ngSwitchCase]="true">
        ${require("./organisationInfoEdit.component.html")}
      </template>
      <template ngSwitchDefault>
        ${require("./organisationInfo.component.html")}
      </template>
    </div>
  `,
  providers: [UserOrganisationInfoService],
})
export class UserOrganisationInfoComponent implements OnInit {
  @Input() userOrganisations: Organisation[];
  @Input() accountIdToUse: string; // For impersonation use only
  @Output() handleProcessing: EventEmitter<any> = new EventEmitter();
  dioceseList: Diocese[];
  organisationList: Organisation[];
  organisationListObservable: Observable<Organisation[]>;
  jobTitleList: JobTitle[];
  roleList: AccountRole[];
  statusCodeList: OrganisationStatus[];
  organisationModel: Organisation;
  errors: Error[];
  organisationLegendTitle: string;
  errorMessage: string;
  isEditMode: boolean;
  isAddEditUIMode: boolean;
  ngbFromDate: NgbDateStruct;
  ngbToDate: NgbDateStruct;
  isProcessing: boolean;
  isError: boolean;
  hasEditPermission: boolean;
  hasControlEditPermission: boolean = true;
  canSelectNetIdPositionType: boolean = true;
  disableEditStatus: boolean = false;
  impExternalOrganisationId: string;
  currentUserExtOrganId: string;
  isRequest: boolean = false;
  orginalRoleCode: string;
  orginalOrganisationStatusCode: string;
  constructor(
    private pService: NgProgressService,
    private currentUserService: CurrentUserService,
    private _router: Router,
    private cecActivatedRoute: ActivatedRoute,
    private userOrganisationInfoService: UserOrganisationInfoService,
    private userHomeService: UserHomeService,
    private staticUserDataService: StaticUserDataService,
    private commonUtility: CommonUtility,
    private ref: ChangeDetectorRef
  ) {}

  // returns true if current user is either a school/org admin, a diocesan admin or global admin
  private isAdministrator() {
    return (
      this.currentUserService.IsGlobalAdmin() ||
      this.currentUserService.IsDiocesanAdmin() ||
      this.currentUserService.IsOrgAdmin()
    );
  }
  private IsGlobalAdmin() {
    return this.currentUserService.IsGlobalAdmin();
  }
  public checkEditPermission(extOrganisationId) {
    // global admins can edit all
    if (this.currentUserService.IsGlobalAdmin() || this.currentUserService.IsDiocesanAdmin())
     {
      return true;
     }
    // org admins for current org can edit users of that org
    if (extOrganisationId === this.currentUserService.userInfo.organisation.extOrganisationId && this.isAdministrator()) {
      return true;
    }
    // current user is looking at his own records (no userid parameter), go ahead
    if (this.currentUserService.token && !this.cecActivatedRoute.snapshot.queryParams[USERHOMECONSTANTS.params.userId]) {
      return true;
    }
  }

  // region: Event handlers
  ngOnInit() {
    this.errorMessage = "";
    this.impExternalOrganisationId = "";
    this.errors = [];
    this.isAddEditUIMode = false;
    this.isEditMode = false;
    this.isProcessing = false;
    this.organisationModel = new Organisation();
    this.currentUserExtOrganId = this.currentUserService.userInfo.organisation.extOrganisationId;

    // Apply security rules
    let token = this.currentUserService.token;
    this.hasEditPermission = this.isAdministrator() || (token && !this.cecActivatedRoute.snapshot.queryParams[ USERHOMECONSTANTS.params.userId]);
    this.hasControlEditPermission = this.isAdministrator();
    let userIDparam = USERHOMECONSTANTS.params.userId;

    if (token && this.cecActivatedRoute.snapshot.queryParams[userIDparam] && this.currentUserService.IsOrgAdmin()) {
      this.impExternalOrganisationId = this.currentUserExtOrganId;
    }

    // Get diocese list
    this.userOrganisationInfoService.GetDioceseList().subscribe(
      (response: Diocese[]) => {
        this.dioceseList = response;
      },
      error => {
        let paersedErrors = JSON.parse(error._body);
        if (paersedErrors) {
          this.errorMessage = paersedErrors.message;
          this.errors = paersedErrors.errors;
        }
      }
    );

    this.GetJobTitles();
    this.GetRoles();
    this.statusCodeList = this.staticUserDataService.GetOrganisationStatusList();
  }

  // Determine if the Position Type dropdown box should be disabled or not
  isPositionTypeDisabled() {
    // this.organisationModel.isRoleCodeAlterable is strictly compared to false in case it is undefined at certain points
    return !this.hasControlEditPermission || !this.canSelectNetIdPositionType; // || this.organisationModel.isRoleCodeAlterable === false;
  }

  // Determine if the Status dropdown box should be disabled or not
  isStatusDropdownDisabled() {
    // status dropdown is only disabled when current user is not an admin
    // note: non-admin users cannot edit their own or other user's membership
    return !this.isAdministrator();
  }

  // This method sends a request to the server's API to determine if the role of the user should be changed or not according to the position
  // enforceChange should be false for when the page is loaded, and true when user actively changed the position value.
  determineNetIdRole(enforceChange = true) {
    this.userOrganisationInfoService
      .GetRoleByPositionCode(
        this.organisationModel.jobTitle,
        this.organisationModel.roleCode,
        enforceChange
      )
      .subscribe(
        response => {
          // expects a string value for the global role code
          this.organisationModel.roleCode = response.roleCode;
          this.organisationModel.isRoleCodeAlterable =
            response.isRoleCodeAlterable;
          this.isRequest = this.orginalRoleCode === "Standard" &&
            this.organisationModel.roleCode !== "Standard"; 
            this.organisationModel.statusCode = this.orginalOrganisationStatusCode;
          if (this.isRequest) {
            this.organisationModel.statusCode = "Pending";
          }
          this.ref.detectChanges();
        },
        error => {
          let paersedErrors = JSON.parse(error._body);
          if (paersedErrors) {
            this.errorMessage = paersedErrors.message;
          }
        }
      );
  }

  onOrganisationAddSubmit() {
    let token = this.currentUserService.token;
    this.isAddEditUIMode = true;
    this.isEditMode = false;
    this.hasControlEditPermission = true;
    this.ngbFromDate = null;
    this.ngbToDate = null;
    this.organisationModel = new Organisation();
    this.organisationLegendTitle = "Add Organisation";
    this.canSelectNetIdPositionType =
      this.currentUserService.IsGlobalAdmin() ||
      this.currentUserService.IsDiocesanAdmin() ||
      this.currentUserService.IsOrgAdmin();
    if (!this.canSelectNetIdPositionType) {
      this.organisationModel.roleCode =
        CONFIGURATION.organisationRoles.standard;
    }
    const connectionNames = this.currentUserService.getConnectionNames();
    this.organisationListObservable = this.userOrganisationInfoService.GetOrganisationsByConnectionName(connectionNames);
  }

  onOrganisationEditSubmit(id) {
    this.isAddEditUIMode = true;
    this.isEditMode = true;
    this.canSelectNetIdPositionType = true;
    // this.disableEditStatus = this.userOrganisations.length === 1;
    this.organisationLegendTitle = "Edit Organisation";
    let found = this.userOrganisations.find(o => o.accountOrganisationId === id);
    this.organisationModel = _.clone(found);
    this.orginalRoleCode = this.organisationModel.roleCode;
    this.orginalOrganisationStatusCode = this.organisationModel.statusCode;
    // Set position/job title
    let jobTitleFound = this.jobTitleList.find(
      o => o.code === this.organisationModel.jobTitle
    );
    if (!jobTitleFound) {
      this.organisationModel.otherJobTitle = this.organisationModel.jobTitle;
      this.organisationModel.jobTitle = USERHOMECONSTANTS.otherJobTitle;
    }

    if (this.organisationModel.fromDate) {
      this.ngbFromDate = this.commonUtility.ConvertDateStringToNgbDate(
        this.organisationModel.fromDate.toString()
      );
    }
    if (this.organisationModel.toDate) {
      this.ngbToDate = this.commonUtility.ConvertDateStringToNgbDate(
        this.organisationModel.toDate.toString()
      );
    }

    this.orginalRoleCode = this.organisationModel.roleCode;
    const connectionNames = this.currentUserService.getConnectionNames();
    this.organisationListObservable = this.userOrganisationInfoService.GetOrganisationsByConnectionName(connectionNames);
  }

  private onEditOrganisationSubmit(): void {
    
    if (!this.validateEmail(this.organisationModel.email)) {
      this.errorMessage = "Input validation failed:";
      this.errors.push({ code: "email", message: "Please provide a valid email address" });
      swal({
        title: "Input validation failed!",
        text: "Please provide a valid email address.",
        type: "error",
        showCancelButton: false,
        confirmButtonText: "Ok"
      });
      this.isProcessing = false;
      return;
    }
    
    if (this.isRequest) {
      this.organisationModel.statusCode = "Pending";
    }

    this.userOrganisationInfoService
      .Update(this.organisationModel)
      .subscribe(
        (response: Organisation) => {
          this.isAddEditUIMode = false;
          if (!this.isRequest) {
            swal({
              title: "Update Confirmed!",
              text: "Request has been processed successfully",
              type: "success",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1500
          });
          } else {
            swal({
              title: "Update Confirmed!",
              text: "Organisation request has been added successfully and waiting for Principal approval",
              type: "success",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1500
          });
          }
          let impUserId = this.cecActivatedRoute.snapshot.queryParams[
            USERHOMECONSTANTS.params.userId
          ];
          if (impUserId) {
            let navigationExtras = {
              queryParams: {
                userId: impUserId,
                tabId: USERHOMECONSTANTS.tabIds.myDetailsId,
                detailTabId: 1,
              },
            };
            this._router.navigate(["/home"], navigationExtras);
          } else {
            this._router.navigate(["/home"], {
              queryParams: {
                tabId: USERHOMECONSTANTS.tabIds.myDetailsId,
                detailTabId: 1,
              },
            });
          }
          this.handleProcessing.emit(false);
          this.isAddEditUIMode = false;
        },
        error => {
          let parsedErrors = JSON.parse(error._body);

          if (parsedErrors) {
            swal(
              "Failed to Save organisation",
              parsedErrors.errors[0].message,
              "error"
            );
          }
        }
      )
      .add(t => {
        this.handleProcessing.emit(false);
        this.isProcessing = false;
      });
  }

public filter(organisations: Organisation[] ): Organisation[] {
  if (!Array.isArray(organisations)) {
    return [];
  }
  return organisations.filter(o => {
    const id = o && o.extOrganisationId ? o.extOrganisationId.toUpperCase() : "";
    return id !== '0778F56A-70FB-4A32-94D9-151828E21287';
  });
}

  private onAddOrganisationSumbit(): void {
    this.organisationModel.accountId = this.accountIdToUse;
    this.userOrganisationInfoService
      .Add(this.organisationModel)
      .subscribe(
        (response: Organisation) => {
          swal(
            "Add Confirmed!",
            "Organisation request has been added successfully and waiting for Principal approval",
            "success"
          );
          let navigationExtras = {
            queryParams: {
              tabId: USERHOMECONSTANTS.tabIds.myDetailsId,
              detailTabId: 1,
            },
          };
          this.isAddEditUIMode = false;
          this.handleProcessing.emit(false);
          this._router.navigate(["/home"], navigationExtras);
        },
        error => {
          let parsedErrors = JSON.parse(error._body);
          if (parsedErrors) {
            this.errorMessage =
              "You have an overlapping date range, please read help documentation!";
            this.errors = parsedErrors.errors;
            let popupMessage =
              "Failed to add organisation. Please try later...";
            let title = parsedErrors.message;
            if (this.errors) {
              popupMessage =
                "You have an overlapping date range, please read help documentation!";
              title = "Invalid Date Range";
            }
            swal(title, popupMessage, "error");
          }
        }
      )
      .add(t => {
        this.handleProcessing.emit(false);
        this.isProcessing = false;
      });
  }
  onOrganisationInfoSave() {
    this.pService.start();
    this.errorMessage = "";
    this.errors = [];
    this.isProcessing = true;
    this.handleProcessing.emit(true);
    // Set job title before submit
    if (this.organisationModel.jobTitle === USERHOMECONSTANTS.otherJobTitle) {
      this.organisationModel.jobTitle = this.organisationModel.otherJobTitle;
    }

    if (this.organisationModel.accountOrganisationId) {
      this.onEditOrganisationSubmit();
    } else {
      this.onAddOrganisationSumbit();
    }
    this.pService.done();
  }

  onOrganisationEditCancel() {
    this.isAddEditUIMode = false;
    this.isProcessing = false;
    this.organisationModel = new Organisation();
    this.errorMessage = null;
  }

  onHandleProcessing(isProcessing) {
    //   this.isProcessing = isProcessing;
  }

  onDioceseIdChange(dioceseId) {
    const connectionNames = this.currentUserService.getConnectionNames();
    this.organisationListObservable = this.userOrganisationInfoService.GetOrganisationsByConnectionName(connectionNames);
  }

  onFromDateChange(fromDate) {
    this.ngbFromDate = fromDate;
    this.organisationModel.fromDate = new Date(
      this.ngbFromDate.year,
      this.ngbFromDate.month - 1,
      this.ngbFromDate.day
    );
  }

  onToDateChange(toDate) {
    this.ngbToDate = toDate;
    this.organisationModel.toDate = new Date(
      this.ngbToDate.year,
      this.ngbToDate.month - 1,
      this.ngbToDate.day
    );
  }

  onJobTitleChange(jobTitle) {
    this.organisationModel.jobTitle = jobTitle;
    // Reset other job title
    if (jobTitle !== USERHOMECONSTANTS.otherJobTitle) {
      this.organisationModel.otherJobTitle = "";
    }
    this.determineNetIdRole();
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  public GetOrganisationByExtOrganisationId(extOrganisationId, userId) {
    this.userOrganisationInfoService
      .GetOrganisationByExtOrganisationId(extOrganisationId, userId)
      .subscribe(
        (response: Organisation) => {
          this.organisationModel = response;
          const connectionNames = this.currentUserService.getConnectionNames();
          this.userOrganisationInfoService
            .GetOrganisationsByConnectionName(connectionNames)
            .subscribe(
              (orgResponse: Organisation[]) => {
                this.organisationList = orgResponse;
              },
              error => {
                let paersedErrors = JSON.parse(error._body);
                if (paersedErrors) {
                  this.errorMessage = paersedErrors.message;
                  this.errors = paersedErrors.errors;
                } 
              }
            );
        },
        error => {
          let paersedErrors = JSON.parse(error._body);
          if (paersedErrors) {
            this.errorMessage = paersedErrors.message;
          }
        }
      );
  }

  public GetJobTitles() {
    // Get global roles list list
    this.userOrganisationInfoService.GetJobTitles().subscribe(
      (response: JobTitle[]) => {
        this.jobTitleList = _.sortBy(response, "name");
      },
      error => {
        let paersedErrors = JSON.parse(error._body);
        if (paersedErrors) {
          this.errorMessage = paersedErrors.message;
        }
      }
    );
  }

  public GetRoles() {
    // Get global roles list list
    this.userOrganisationInfoService.GetRoles().subscribe(
      (response: AccountRole[]) => {
        this.roleList = response;
      },
      error => {
        let paersedErrors = JSON.parse(error._body);
        if (paersedErrors) {
          this.errorMessage = paersedErrors.message;
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/userDetails/organisationInfo/organisationInfo.component.ts